import { useCallback } from 'react'
import { useOurStore } from '@/app/_providers/StoreProvider'

type UseReset = {
  doReset: (props: DoResetProps) => Promise<void>
}

export enum CartResetType {
  Full,
  CompleteReset,
  NoCart,
  LocalItemsAndCart,
  LocalItemsOnly,
  CartOnly,
  DateAndTime,
  StartTimeAndLocalItems,
}

export type DoResetProps = {
  type: CartResetType
}

export const useReset = (): UseReset => {
  const resetPartial = useOurStore((store) => store.resetPartial)
  const resetAll = useOurStore((store) => store.resetAll)
  const resetByKeys = useOurStore((store) => store.resetByKeys)
  const resetByGroups = useOurStore((store) => store.resetByGroups)

  const doReset = useCallback(({ type }: DoResetProps): Promise<void> => new Promise((resolve) => {
    switch (type) {
    case CartResetType.NoCart:
      resetPartial()
      break

    case CartResetType.Full:
      resetPartial()
      break

    case CartResetType.CompleteReset:
      resetAll()
      break

    case CartResetType.LocalItemsAndCart:
      resetByGroups(['cart', 'dateAndTime'])
      break

    case CartResetType.LocalItemsOnly:
      resetByGroups([
        'localItems',
      ])
      break

    case CartResetType.CartOnly:
      resetByGroups(['cart'])
      break

    case CartResetType.DateAndTime:
      resetByGroups(['dateAndTime'])
      break

    case CartResetType.StartTimeAndLocalItems:
      resetByKeys([
        'activeDate',
        'activeStartTime',
        'localLineItems',
        'lineItemsToDelete',
        'admissionType',
      ])
      break

    default:
      // do nothing
      break
    }
    resolve()
  }), [resetPartial, resetAll, resetByKeys, resetByGroups])

  return { doReset }
}
